import { useCallback } from 'react';
import { useRequest } from '@Hooks';
import { API } from '@Services';
import { ApiErrorObject } from '@Types';

export const useDeleteSelection = () => {
  const [fetch, response] = useRequest<null | ApiErrorObject>();

  const deleteSelection = useCallback(
    (fundId: number, selectionId: number) =>
      fetch(API.paths.fund_selection(fundId, selectionId), 'delete', {
        data: null,
      }),
    [fetch],
  );

  return [deleteSelection, response] as const;
};
